import { render, staticRenderFns } from "./TransportForm.vue?vue&type=template&id=1acfad13"
import script from "./TransportForm.vue?vue&type=script&lang=js"
export * from "./TransportForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports